<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-03 11:45:05
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-09 14:16:56
 * @name: 人员选择
 * @Description: 人员选择
 * @FilePath: \project\src\components\public\people-seleter.vue
 * @Author: desktop
-->
<template>
  <el-dialog
    title="人员选择"
    width="700px"
    :visible.sync="show"
    @close="closeHandler"
  >
    <div class="container">
      <div class="history" v-if="historys && historys.length > 0">
        <div class="item-info" @click="history_open = !history_open">
          <div class="icon">
            <template v-if="historys && historys.length > 0">
              <i class="el-icon-caret-bottom" v-if="history_open"></i>
              <i class="el-icon-caret-right" v-else></i>
            </template>
          </div>
          <font>历史选择</font>
        </div>
        <div class="item-detail" v-show="history_open">
          <div
            class="department_user_list"
            v-if="historys && historys.length > 0"
          >
            <div
              class="department_user"
              v-for="item of historys"
              :key="item.id"
              @click="peopleClickHandler(item)"
            >
              <div
                class="checkbox"
                :class="{
                  checked: select.findIndex((x) => x.id === item.id) > -1,
                }"
              >
                <i
                  class="el-icon-check"
                  v-if="select.findIndex((x) => x.id === item.id) > -1"
                ></i>
              </div>
              <font>{{ item.realname }}</font>
            </div>
          </div>
        </div>
      </div>
      <people-item
        :select="select"
        :item="item"
        v-for="item of list"
        :key="item.id"
        @peopleClickHandler="peopleClickHandler"
      ></people-item>
      <el-button size="mini" type="primary" class="confirm" @click="confirm"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import departmentService from "@/module/department/department.service";
import issueService from "@/module/issue/issue.service";
import peopleItem from "@/components/public/people-item.vue";
import { debounceation } from '@/utils/decorator';
const select_origin = [];
export default {
  components: {
    peopleItem,
  },
  props: {
    // 是否多选
    multiple: {
      type: Boolean,
      default: false,
    },
    // 选择类型 sender 发件人 todoor 上门人
    type: {
      type: String,
    },
  },
  data() {
    return {
      departmentService: new departmentService(),
      issueService: new issueService(),
      show: false,
      historys: [],
      history_open: false,
      list: [],
      select: JSON.parse(JSON.stringify(select_origin)),
      props: {
        label: "department_name",
        children: "child",
      },
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Array} select 已选人员
     */
    open(select) {
      if (!this.multiple && select.length > 1) {
        console.error("单选模式select数组长度不得大于1");
        return;
      }
      this.departmentService.getList().then((res) => {
        this.select = select || JSON.parse(JSON.stringify(select_origin));
        this.show = true;
        this.list = res.data.department_list;
        if (this.type === "sender") {
          this.issueService.getReplacementPartsUser().then((res) => {
            this.historys = res.data.map((x) => {
              return {
                id: x.user_id,
                realname: x.real_name,
              };
            });
          });
        } else if (this.type === "todoor") {
          this.issueService.getLastHomeServiceUser().then((res) => {
            this.historys = res.data.map((x) => {
              return {
                id: x.user_id,
                realname: x.real_name,
              };
            });
          });
        }
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 弹窗关闭回调
     */
    closeHandler() {
      this.select = JSON.parse(JSON.stringify(select_origin));
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 选择人员
     * @param {String} item 人员信息
     */
    peopleClickHandler(item) {
      if (this.multiple) {
        if (this.select.findIndex((x) => x.id === item.id) > -1) {
          this.select.splice(
            this.select.findIndex((x) => x.id === item.id),
            1
          );
        } else {
          this.select.push(item);
        }
      } else {
        if (this.select.findIndex((x) => x.id === item.id) > -1) {
          this.select.splice(
            this.select.findIndex((x) => x.id === item.id),
            1
          );
        } else {
          this.$set(this.select, 0, item);
        }
      }
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确认
     */
    @debounceation(300)
    confirm() {
      if (this.select.length === 0) {
        this.$message.error("请选择人员");
        return;
      }
      this.$emit("peopleSelect", this.select);
      this.show = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  @extend .et-flex-column-center;
  .history {
    width: 100%;
    @extend .et-flex-column-normal;
    .item-info {
      width: 100%;
      padding: 3px 0;
      @extend .et-flex-start;
      @extend .et-clickElement;
      i {
        width: 15px;
        height: 15px;
        margin-right: 5px;
        font-size: 15px;
      }
    }
    .item-detail {
      width: 100%;
      box-sizing: border-box;
      padding-left: 10px;
      .department_user_list {
        width: 100%;
        @extend .et-flex-column-normal;
        .department_user {
          width: 100%;
          box-sizing: border-box;
          padding: 3px 10px;
          @extend .et-flex-start;
          @extend .et-clickElement;
          .checkbox {
            width: 12px;
            height: 12px;
            margin-right: 5px;
            border: 1px solid $Vars-border-first-color;
            border-radius: $Vars-border-radius-mini;
            &.checked {
              border-color: $Vars-normal-color;
              background: $Vars-normal-color;
            }
            @extend .et-flex-center;
            i {
              font-size: $Vars-font-secondary-size;
              color: white;
            }
          }
        }
      }
    }
  }
  .confirm {
    margin-top: 30px;
  }
}
</style>